import { FormActions } from '@app/components/form/FormActions';
import { AUDIOGRAM_TARGET_VARIANTS } from '@app/modules/fragments/screens/view/components/audiogram/consts';
import { audiogramDefaultStyleProps } from '@mi-front/audiogram';
import { NullState } from '@mi-front/ui';
import AddIcon from '@mui/icons-material/Add';
import DesignServicesIcon from '@mui/icons-material/DesignServices';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useFieldArray, useFormContext } from 'react-hook-form-mui';
import { FormattedMessage, useIntl } from 'react-intl';
import { FormValues } from '../types';
import { TemplatePanel } from './TemplatePanel';

export function TemplateForm() {
  const { $t } = useIntl();
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'templates',
  });

  const addTemplate = () => {
    append({
      name: $t(
        { id: 'audiogram.templateNumber', defaultMessage: 'Template {number}' },
        { number: fields.length + 1 },
      ),
      default: false,
      data: {
        ...audiogramDefaultStyleProps,
        variants: AUDIOGRAM_TARGET_VARIANTS.map((v) => v.value),
      },
    });
  };

  return (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="subtitle1">
          <DesignServicesIcon fontSize="small" />{' '}
          <FormattedMessage id="audiogram.templates" defaultMessage="Templates" />
        </Typography>
        <Button startIcon={<AddIcon />} onClick={addTemplate} variant="outlined" size="small">
          <FormattedMessage id="audiogram.newTemplate" defaultMessage="Nuevo template" />
        </Button>
      </Stack>

      {fields.length === 0 ? (
        <NullState>
          <FormattedMessage
            id="audiogram.noTemplatesDefined"
            defaultMessage="No hay templates definidos aún"
          />
        </NullState>
      ) : (
        <Stack spacing={2}>
          {fields.map((field, index) => (
            <TemplatePanel key={field.id} index={index} onRemove={() => remove(index)} />
          ))}
        </Stack>
      )}

      {errors.templates?.root && <Alert severity="error">{errors.templates.root.message}</Alert>}

      <FormActions></FormActions>
    </Stack>
  );
}
